module.exports = __webpack_public_path__ + "img/italy-neoplasm-male.26b9700e.png";